import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import MDBox from 'components/MDBox';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';

export default function AppShellLayout() {
  const loc = useLocation();
  const path = loc.pathname || '';

  // ✅ /app dışı her şeyde: shell yok (landing dahil)
  if (!path.startsWith('/app')) {
    return (
      <MDBox sx={{ minHeight: '100vh' }}>
        <Outlet />
      </MDBox>
    );
  }

  // ✅ Setup ekranında: sidebar + navbar + footer yok
  if (path.startsWith('/app/setup')) {
    return (
      <MDBox sx={{ minHeight: '100vh' }}>
        <Outlet />
      </MDBox>
    );
  }

  // ✅ Normal app: sidebar (DashboardLayout) + navbar + footer var
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DashboardNavbar />

        <MDBox
          component="main"
          sx={{
            flex: '1 1 auto',
            minHeight: 0,
            overflowY: 'visible',
          }}
        >
          <Outlet />
        </MDBox>

        <Footer />
      </MDBox>
    </DashboardLayout>
  );
}
